import { render, staticRenderFns } from "./LiveStocks.vue?vue&type=template&id=51de53ae&"
import script from "./LiveStocks.vue?vue&type=script&lang=js&"
export * from "./LiveStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports